import {on} from 'delegated-events'

on('click', '.js-org-discussion-toggle', (event: Event) => {
  const checkbox = event.currentTarget as HTMLInputElement
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const selectRepo = document.querySelector<HTMLElement>('.js-org-level-discussion-form')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const submitButton = document.querySelector<HTMLButtonElement>('#js-submit-button')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const repoSelected = document.getElementById('js-selected-repository-name')!

  if (submitButton) {
    if (checkbox.checked) {
      selectRepo.hidden = false
      if (repoSelected.textContent === 'Choose a repository') {
        submitButton.disabled = true
      }
    } else {
      selectRepo.hidden = true
      submitButton.disabled = false
    }
  }
})

on('click', '.js-org-level-repo-select-form input[name=repo_id]', async event => {
  const input = event.currentTarget as HTMLInputElement
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const label = document.getElementById('js-selected-repository-name')!

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const text = input.closest('.select-menu-item-text')!.querySelector('.js-repository-name')!.textContent
  const button = document.getElementById('js-submit-button') as HTMLButtonElement

  if (button) {
    button.disabled = false
  }

  if (text && label) {
    label.textContent = text
  }
})
